import React, { useState } from "react";
import {
  FaFlask,
  FaSearch,
  FaPhoneAlt,
  FaHandshake,
  // FaPlus,
  // FaMinus,
} from "react-icons/fa";
import { IoMail } from "react-icons/io5";
import { FaGears } from "react-icons/fa6";
import "../../Template02/Combined.css";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";

function ServicesPage() {
  // ServiceCard Component
  function ServiceCard({ icon: Icon, title, description }) {
    return (
      <div className="col-lg-4 col-sm-6">
        <div className="icon-box item">
          <div className="iconWidget icon-services">
            <Icon size={50} />
          </div>
          <div className="richTextWidget">
            <h4 className="title">{title}</h4>
            <p>{description}</p>
          </div>
        </div>
      </div>
    );
  }

  // FAQItem Component
  function FAQItem({ question, answer }) {
    const [isOpen, setIsOpen] = useState(false);

    const toggleFAQ = () => setIsOpen(!isOpen);

    return (
      <div className="panel panel-default">
        <div className="panel-heading">
          <div
            style={{ cursor: "pointer" }}
            onClick={toggleFAQ}
            className={isOpen ? "expanded" : ""}
            aria-expanded={isOpen}
            aria-controls={`faq-answer-${question}`}
          >
            <div className="d-flex gap-3">
              {/* {!isOpen ? <FaPlus /> : <FaMinus />} */}
              <h4 className="panel-title"><li>{question}</li></h4>
            </div>
          </div>
        </div>
        {isOpen && (
          <div className="panel-collapse">
            <div
              id={`faq-answer-${question}`}
              className="panel-body richTextWidget"
            >
              {answer}
            </div>
          </div>
        )}
      </div>
    );
  }

  // Services Data
  const services = [
    {
      icon: FaFlask,
      title: "Formulation Research & Development",
      description:
        "Our research team specializes in developing innovative and effective pharmaceutical formulations, focusing on novel drug delivery systems and improving patient outcomes.",
    },
    {
      icon: FaGears,
      title: "Medical Device Development",
      description:
        "We design and develop medical devices that meet the highest standards, from diagnostic tools to therapeutic devices, advancing healthcare through innovation.",
    },
    {
      icon: FaSearch,
      title: "Preclinical & Clinical Research",
      description:
        "Medisol conducts rigorous preclinical and clinical trials to ensure the safety and effectiveness of new treatments, devices, and drug formulations.",
     },
    {
      icon: IoMail,
      title: "Collaborative Research Partnerships",
      description:
        "We collaborate with leading healthcare providers and research institutions to drive forward innovation in drug development, medical technology, and patient care solutions.",
    },
    {
      icon: FaPhoneAlt,
      title: "Regulatory Compliance & Certification",
      description:
        "We ensure that all our products meet stringent regulatory requirements, from research to market, to ensure safety and quality across regions.",
    },
    {
      icon: FaHandshake,
      title: "Global Distribution of Healthcare Solutions",
      description:
        "Medisol offers a robust global distribution network, ensuring timely and efficient delivery of our pharmaceutical products and medical devices worldwide.",
   },
  ];

  // FAQs Data
  const faqs = [
    {
      question: "What type of medical devices do you manufacture?",
      answer:
        "We specialize in the design and production of a wide array of medical devices, from diagnostic equipment and monitoring tools to therapeutic devices. Each of our products is designed to meet the highest quality standards, ensuring that they contribute to effective and efficient patient care.",
    },
    {
      question: "Do you offer personalized medication solutions?",
      answer:
        "Yes, we believe in the power of personalized medicine. We collaborate with healthcare providers to create custom medication solutions tailored to individual patient needs, helping to improve treatment outcomes and patient satisfaction.",
    },
    {
      question: "Where do you distribute your products?",
      answer:
        "Medisol-Lab’s products are available worldwide. We have a comprehensive distribution network that allows us to supply our medical devices and pharmaceutical products to hospitals, clinics, and healthcare professionals across multiple continents.",
    },
    {
      question: "What measures do you take to ensure product quality?",
      answer:
        "Quality is our top priority at Medisol-Lab. Our products undergo extensive testing, from initial development through to final production, ensuring compliance with global regulatory standards. We maintain a strong commitment to quality assurance by adhering to the highest industry standards and conducting regular quality checks to guarantee safety, efficacy, and reliability.",
    },
    {
      question: "How can healthcare providers partner with Medisol-Lab?",
      answer:
        "Healthcare providers interested in partnering with Medisol-Lab can reach out to us for collaboration opportunities. Whether you are looking for innovative solutions in drug development, medical device production, or research partnerships, we are open to discussing how we can work together to improve patient outcomes and drive the future of healthcare.",
    },
  ];

  return (
    <>
      {/* Header */}
      <Header />

      <div id="services" className="page wb-page">
        {/* Breadcrumb Section */}
        <section
          id="section-3592607"
          className="breadcrumb-section dark sec-padding-lg"
          style={{
            backgroundImage:
              "url(https://images.pexels.com/photos/20140024/pexels-photo-20140024.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=627&w=1200)",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center center",
          }}
        >
          <div className="container boxWidget">
            <div className="col-lg-6">
              <div className="richTextWidget title-heading">
                <h1>What We Offer</h1>
              </div>
            </div>
          </div>
        </section>


        {/* Services Section */}
        <section id="section-3592611" className="widget-section">
          <div className="container boxWidget">
            <div className="row centered-row">
              <div className="col-lg-12">
                <div className="richTextWidget">
                  <h2 className="heading-big" style={{ textAlign: "center" }}>
                    Our Services
                  </h2>
                  <p style={{ textAlign: "center", marginBottom: 30 }}>
                    Medisol Labs specializes in a range of services to support
                    healthcare providers and improve patient outcomes.
                  </p>
                </div>
              </div>
            </div>
            <div className="row">
              {services.map((service, index) => (
                <ServiceCard key={index} {...service} />
              ))}
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section id="section-3592641" className="section-work-01">
          <div className="richTextWidget col-lg-12">
            <h2 className="heading-big" style={{ textAlign: "center" }}>
              FAQ
            </h2>
            <p style={{ textAlign: "center", marginBottom: 30 }}>
              Find answers to common questions about our research and development processes, as well as our products and services.
            </p>
          </div>
          <div className="col-lg-6">
            {faqs.map((faq, index) => (
              <FAQItem key={index} {...faq} />
            ))}
            <div style={{display:"flex",justifyContent:"end",alignItems:"center",marginBottom:"10px"}}>
              <div style={{padding:"8px 30px",background:"#d10f56",color:"#fff",borderRadius:"10px"}}>More</div>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-12">
            <div className="imageWidget about-image-large Img3">
              <img
                className="lazyload faq-img"
                src="//images.pexels.com/photos/7904433/pexels-photo-7904433.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=627&w=1200"
                alt="FAQ"
              />
            </div>
          </div>
        </section>
      </div>

      {/* Footer */}
      <Footer />
    </>
  );
}

export default ServicesPage;
